import styled, { css, keyframes } from "styled-components";

import componentSizes from "../constants/componentSizes";
import { Body as DsBody } from "../typography";
import { colors, orientations } from "./constants";

const strokeWidth = 12;
const radius = (100 - strokeWidth) / 2;
const circumference = Math.ceil(2 * 3.14 * radius);
const strokeOffset = circumference / 10;

export const Circle = styled.circle.attrs({
  cx: 50,
  cy: 50,
  r: radius
})`
  fill: transparent;
  stroke: ${({ color }) => color};
  stroke-dasharray: ${circumference};
  stroke-dashoffset: ${strokeOffset};
  stroke-width: ${strokeWidth};
`;

const rotateAnimation = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const loaderSizeMap = {
  [componentSizes.SM]: 14,
  [componentSizes.MD]: 24,
  [componentSizes.LG]: 32
};

const loaderBodyStyles = {
  [orientations.VERTICAL]: css`
    margin-top: 8px;
    text-align: center;
  `,
  [orientations.HORIZONTAL]: css`
    margin-left: 8px;
    text-align: left;
  `
};

const orientationMap = {
  [orientations.VERTICAL]: "column",
  [orientations.HORIZONTAL]: "row"
};

const svgHeightWidth = ({ size }) => {
  const pixels = loaderSizeMap[size];

  return `
    width: ${pixels}px;
    height: ${pixels}px;
  `;
};

export const Svg = styled.svg.attrs({
  focusable: "false",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
})`
  ${svgHeightWidth};
  animation: ${rotateAnimation} 1s linear infinite;
`;

export const Loader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: ${({ orientation }) => orientationMap[orientation]};
`;

const withLoaderBodyStyles = ({ orientation }) => loaderBodyStyles[orientation];

const textColor = ({ color }) => {
  if (color === colors.GRAY_LIGHT) {
    return `color: ${colors.GRAY_LIGHT};`;
  }

  return null;
};

export const Body = styled(DsBody)`
  ${textColor}
  ${withLoaderBodyStyles}
  max-width: 256px;
`;
